import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { billingService, BillingStatus, ActiveGateway } from '../services/billing.service';

export const BILLING_STATUS_KEY = ['billing', 'status'];

export function useBillingStatus() {
  return useQuery<BillingStatus>({
    queryKey: BILLING_STATUS_KEY,
    queryFn: async () => {
      const res = await billingService.getBillingStatus();
      return res.data as BillingStatus;
    },
    staleTime: 60_000,
    refetchInterval: 5 * 60_000, // recheck every 5 min
    retry: false,
  });
}

export function usePlans() {
  return useQuery({
    queryKey: ['billing', 'plans'],
    queryFn: async () => {
      const res = await billingService.getPlans();
      return res.data ?? [];
    },
    staleTime: 10 * 60_000,
  });
}

export function useActiveGateways() {
  return useQuery<ActiveGateway[]>({
    queryKey: ['billing', 'gateways'],
    queryFn: async () => {
      const res = await billingService.getActiveGateways();
      return res.data ?? [];
    },
    staleTime: 5 * 60_000,
  });
}

export function useStartTrial() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => billingService.startTrial(),
    onSuccess: () => qc.invalidateQueries({ queryKey: BILLING_STATUS_KEY }),
  });
}
